function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    width: 406,
    height: 306,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2563EB"
    },
    d: "M241.516,161.25c17.081-6.045,35.948-8.644,53.359-3.626 c13.094,3.775,34.965,36.689,28.724,75.832c-2.686,16.845,9.32,34.296,25.404,44.367c7.621,4.772,17.409,4.013,26.026,5.191 c19.11,2.614,38.169,16.277,40.385,35.438c2.14,18.508-12.539,40.294-23.724,54.004c-28.804,35.306-79.911,54.433-123.709,35.228 c-21.237-9.312-39.77-29.023-54.61-46.432c-15.556-18.25-22.566-42.661-23.732-66.27c-1.446-29.271,5.163-58.124,12.436-86.269 C207.633,187.207,219.733,168.959,241.516,161.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#14B8A6"
    },
    d: "M189.346,333.669c-1.956-6.202-4.307-12.443-8.5-17.413 c-5.814-6.891-14.49-10.583-22.921-13.778c-7.816-2.962-15.804-5.725-24.117-6.591c-21.492-2.238-43.778,9.711-53.809,28.849 c-3.31,6.314-5.15,14.595-0.712,20.174c1.94,2.439,4.789,3.946,7.553,5.385c9.287,4.835,18.574,9.67,27.861,14.505 c9.702,5.051,20.713,12.059,21.132,22.989c0.408,10.652-6.227,19.919,3.728,28.535c6.699,5.799,19.123,7.828,27.644,5.797 c18.852-4.493,26.683-30.159,28.038-46.925C196.378,361.138,193.558,347.023,189.346,333.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#F97316"
    },
    d: "M185.162,177.565c6.959-19.463,0.33-59.583-17.765-71.53 c-8.396-5.543-16.826-6.066-26.117-2.803c-8.491,2.983-16.953,7.426-23.889,13.198c-6.092,5.07-10.308,12.018-13.817,19.026 c-6.657,13.295-12.316,30.319-27.17,36.589c-5.703,2.407-12.211,2.805-17.529,5.973c-11.945,7.117-11.867,26.205-2.27,35.378 c8.244,7.88,21.709,10.42,32.632,10.253C128.454,223.05,172.266,213.633,185.162,177.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#7B2CBF"
    },
    d: "M389.537,269.227c20.368,3.522,58.758-9.882,67.429-29.757 c4.023-9.222,3.094-17.617-1.713-26.211c-4.393-7.854-10.221-15.431-17.096-21.275c-6.039-5.133-13.606-8.097-21.111-10.353 c-14.239-4.281-31.981-6.94-40.702-20.501c-3.348-5.206-4.855-11.55-8.888-16.246c-9.058-10.55-27.851-7.202-35.244,3.824 c-6.351,9.472-6.547,23.173-4.511,33.906C335.01,221.15,351.793,262.701,389.537,269.227z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_109_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_122_",
    style: {
      fill: "#F43F5E"
    },
    d: "M154.182,368.841c3.029,0,3.388,0.012,4.584,0.066 c1.106,0.05,1.707,0.235,2.107,0.391c0.529,0.206,0.907,0.451,1.304,0.848c0.397,0.397,0.643,0.775,0.849,1.304 c0.155,0.4,0.34,1,0.391,2.107c0.054,1.196,0.066,1.555,0.066,4.584s-0.012,3.388-0.066,4.584 c-0.051,1.106-0.235,1.707-0.391,2.106c-0.206,0.53-0.451,0.908-0.849,1.305c-0.397,0.397-0.775,0.643-1.304,0.849 c-0.4,0.155-1.001,0.34-2.107,0.391c-1.196,0.054-1.555,0.066-4.584,0.066c-3.029,0-3.388-0.012-4.584-0.066 c-1.106-0.05-1.707-0.235-2.106-0.391c-0.53-0.206-0.908-0.452-1.304-0.849c-0.397-0.397-0.643-0.775-0.849-1.305 c-0.155-0.4-0.34-1-0.391-2.106c-0.055-1.196-0.066-1.555-0.066-4.584s0.012-3.388,0.066-4.584 c0.051-1.106,0.236-1.707,0.391-2.107c0.206-0.529,0.452-0.907,0.849-1.304c0.397-0.397,0.775-0.643,1.304-0.848 c0.4-0.155,1.001-0.34,2.106-0.391C150.794,368.853,151.153,368.841,154.182,368.841 M154.182,366.797 c-3.081,0-3.467,0.013-4.677,0.068c-1.207,0.055-2.032,0.247-2.754,0.527c-0.746,0.29-1.379,0.678-2.009,1.309 c-0.631,0.631-1.019,1.263-1.308,2.009c-0.281,0.722-0.473,1.546-0.527,2.754c-0.055,1.21-0.068,1.596-0.068,4.677 s0.013,3.467,0.068,4.677c0.055,1.207,0.247,2.032,0.527,2.754c0.29,0.746,0.677,1.379,1.308,2.009 c0.631,0.631,1.263,1.018,2.009,1.308c0.722,0.28,1.546,0.472,2.754,0.527c1.21,0.055,1.596,0.068,4.677,0.068 c3.081,0,3.467-0.013,4.677-0.068c1.208-0.055,2.032-0.247,2.754-0.527c0.746-0.29,1.379-0.678,2.01-1.308 c0.631-0.631,1.018-1.264,1.308-2.009c0.28-0.722,0.472-1.546,0.527-2.754c0.055-1.21,0.068-1.596,0.068-4.677 s-0.013-3.467-0.068-4.677c-0.055-1.208-0.247-2.032-0.527-2.754c-0.29-0.746-0.678-1.379-1.308-2.009 c-0.631-0.631-1.263-1.019-2.01-1.309c-0.722-0.28-1.546-0.472-2.754-0.527C157.649,366.811,157.263,366.797,154.182,366.797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_119_",
    style: {
      fill: "#2563EB"
    },
    d: "M154.182,373.017c-2.83,0-5.125,2.295-5.125,5.125 c0,2.831,2.295,5.125,5.125,5.125c2.831,0,5.125-2.295,5.125-5.125C159.307,375.311,157.012,373.017,154.182,373.017  M154.182,381.469c-1.837,0-3.327-1.49-3.327-3.327c0-1.837,1.489-3.327,3.327-3.327s3.327,1.489,3.327,3.327 C157.508,379.979,156.019,381.469,154.182,381.469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_110_",
    style: {
      fill: "#14B8A6"
    },
    d: "M160.668,371.787c0,0.752-0.61,1.362-1.361,1.362 c-0.752,0-1.361-0.61-1.361-1.362c0-0.752,0.609-1.361,1.361-1.361C160.059,370.425,160.668,371.035,160.668,371.787"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_101_",
    style: {
      fill: "#F97316"
    },
    d: "M349.998,200.525c-22.686,0.387-22.684,34.135,0.001,34.519 C372.687,234.656,372.682,200.908,349.998,200.525z M349.998,203.526c3.273,0,6.283,1.12,8.692,2.981 c-1.732,2.235-4.125,4.002-7.172,5.292c-1.461-2.676-3.131-5.286-5.016-7.82C347.622,203.694,348.79,203.526,349.998,203.526z  M343.566,205.077c1.915,2.506,3.611,5.09,5.087,7.74c-3.496,1.029-7.668,1.557-12.491,1.591 C337.159,210.33,339.904,206.939,343.566,205.077z M335.741,217.783c0-0.123,0.017-0.244,0.02-0.367 c5.534-0.008,10.309-0.644,14.309-1.902c0.335,0.683,0.656,1.369,0.964,2.06c-4.86,1.519-8.865,4.633-11.99,9.319 C336.984,224.423,335.741,221.246,335.741,217.783z M349.998,232.042c-3.298,0-6.331-1.135-8.749-3.024 c2.831-4.443,6.448-7.334,10.927-8.669c1.333,3.481,2.315,7.061,2.939,10.729C353.523,231.693,351.803,232.042,349.998,232.042z  M357.912,229.635c-0.63-3.383-1.553-6.691-2.761-9.919c2.697-0.381,5.667-0.283,8.915,0.283 C363.438,224.005,361.15,227.467,357.912,229.635z M354.001,216.875c-0.351-0.81-0.714-1.617-1.103-2.416 c3.321-1.439,5.991-3.392,7.981-5.87c1.94,2.293,3.158,5.205,3.338,8.392C360.512,216.374,357.106,216.341,354.001,216.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#7B2CBF"
    },
    d: "M194.107,178.691c2.872-0.096,5.405-2.775,5.339-5.648 c-0.076-3.318-5.453-5.099-7.715-2.858C188.96,172.931,189.37,178.848,194.107,178.691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#F43F5E"
    },
    d: "M407.457,168.318c7.478-0.249,14.074-7.226,13.903-14.707 c-0.198-8.641-14.201-13.278-20.091-7.441C394.053,153.318,395.12,168.728,407.457,168.318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2563EB"
    },
    d: "M215.703,438.845c10.401-0.346,19.574-10.05,19.335-20.454 c-0.275-12.018-19.75-18.466-27.942-10.349C197.062,417.984,198.546,439.415,215.703,438.845z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14B8A6"
    },
    d: "M201.997,102.837c7.145-1.278,12.507-8.893,11.303-16.051 c-1.391-8.268-15.479-10.774-20.322-4.352C187.045,90.3,190.211,104.946,201.997,102.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M200.504,91.269l-1.61,1.761c-0.242,0.265-0.223,0.675,0.041,0.917 c0.265,0.24,0.674,0.223,0.916-0.042l1.695-1.854l2.009,1.508c0.286,0.214,0.692,0.155,0.908-0.129 c0.215-0.287,0.157-0.694-0.129-0.909l-1.909-1.432l1.61-1.761c0.242-0.264,0.223-0.675-0.041-0.917 c-0.14-0.128-0.323-0.183-0.498-0.167c-0.155,0.014-0.305,0.084-0.418,0.208l-1.695,1.854l-2.009-1.508 c-0.134-0.101-0.295-0.142-0.45-0.127c-0.175,0.016-0.344,0.105-0.458,0.256c-0.215,0.287-0.157,0.694,0.129,0.909 L200.504,91.269z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97316",
      strokeMiterlimit: 10
    },
    d: "M366.444,318.326c14.071-11.916,28.281-23.668,42.626-35.252"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B2CBF",
      strokeMiterlimit: 10
    },
    d: "M428.195,291.923c-5.923,35.457-9.668,57.876-15.59,93.334"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F43F5E",
      strokeMiterlimit: 10
    },
    d: "M353.654,397.031c2.416,0,23.191,7.393,23.191,7.393"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2563EB",
      strokeMiterlimit: 10
    },
    x1: 74.159,
    y1: 311.397,
    x2: 52.597,
    y2: 251.902
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14B8A6"
    },
    d: "M100.409,194.179c12.504-2.763,21.415-16.57,18.782-29.102 c-3.042-14.477-28.056-17.889-36.136-6.223C73.156,173.144,79.781,198.736,100.409,194.179z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_57_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M97.169,162.009c-5.778,0.411-10.129,5.428-9.718,11.206 c0.411,5.778,5.428,10.129,11.206,9.719c5.778-0.411,10.129-5.428,9.718-11.206C107.964,165.949,102.947,161.598,97.169,162.009z  M103.056,176.784c-0.187,0.329-0.546,0.459-0.874,0.272c-2.566-1.342-5.675-1.437-9.277-0.339 c-0.359,0.13-0.691-0.109-0.818-0.415c-0.131-0.359,0.108-0.691,0.415-0.818c3.912-1.172,7.391-1.051,10.23,0.429 C103.109,176.045,103.191,176.459,103.056,176.784z M104.107,173.818c-0.236,0.385-0.695,0.575-1.08,0.34 c-2.948-1.526-7.274-1.744-10.495-0.463c-0.411,0.134-0.897-0.042-1.031-0.452c-0.134-0.411,0.041-0.897,0.452-1.031 c3.737-1.422,8.486-1.182,11.87,0.576C104.148,172.921,104.343,173.433,104.107,173.818z M104.003,170.881 c-3.489-1.75-9.101-1.561-12.221-0.341c-0.512,0.194-1.057-0.083-1.248-0.542c-0.194-0.512,0.082-1.057,0.542-1.248 c3.636-1.362,9.771-1.588,13.806,0.438c0.489,0.228,0.691,0.845,0.463,1.334C105.11,170.908,104.493,171.109,104.003,170.881z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97316",
      strokeWidth: 0.906,
      strokeMiterlimit: 10
    },
    d: "M144.458,136.755 c0,0-9.011,0.061-11.03,0.065c-1.132,0.003-1.271-1.806-1.113-2.277c0.074-0.221,0.25-0.39,0.422-0.548 c1.598-1.467,5.822-4.506,5.995-4.896c0.318-0.714-4.048-7.573-3.632-11.652c0.462-4.525,4.404-8.46,9.357-8.143h-0.588 c4.953-0.317,8.895,3.618,9.357,8.143c0.416,4.078-3.949,10.938-3.632,11.652c0.174,0.39,4.397,3.429,5.995,4.896 c0.172,0.158,0.349,0.327,0.422,0.548c0.157,0.471,0.019,2.279-1.113,2.277c-2.019-0.005-11.03-0.065-11.03-0.065H144.458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B2CBF",
      strokeMiterlimit: 10
    },
    d: "M409.394,220.639c0,0-9.945,0.067-12.174,0.072 c-1.25,0.003-1.403-1.993-1.229-2.513c0.081-0.244,0.277-0.431,0.466-0.605c1.764-1.619,6.426-4.973,6.617-5.404 c0.351-0.788-4.468-8.359-4.008-12.86c0.51-4.994,4.861-9.337,10.328-8.987h-0.649c5.467-0.35,9.818,3.993,10.328,8.987 c0.459,4.502-4.359,12.072-4.008,12.86c0.192,0.431,4.853,3.785,6.617,5.404c0.19,0.174,0.385,0.361,0.466,0.605 c0.173,0.52,0.021,2.516-1.229,2.513c-2.228-0.005-12.174-0.072-12.174-0.072H409.394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F43F5E",
      strokeMiterlimit: 10
    },
    d: "M359.702,287.971c-0.971,0.051-1.102-1.589-1.18-2.049 c-0.16-0.951-0.321-1.902-0.482-2.853c-0.127-0.751-0.147-1.557-0.896-1.97c-1.218-0.672-3.27-0.336-3.473-1.291 c-0.25-1.18,2.183-1.048,2.811-1.031c0.615,0.017,1.805-0.019,1.957-0.708c0.132-0.6-0.005-1.086,0-1.692 c0.01-1.219,0.059-2.574,0.202-3.609c0.144-1.045,0.645-2.117,1.06-2.122c0.489-0.006,1.046,0.962,1.204,2.281 c0.116,0.966,0.21,4.542,0.342,5.142c0.152,0.689,1.058,0.724,1.673,0.708c0.628-0.017,3.061-0.149,2.811,1.031 c-0.203,0.956-2.254,0.619-3.473,1.291c-0.749,0.413-0.769,1.219-0.896,1.97c-0.161,0.951-0.321,1.902-0.482,2.853 C360.804,286.382,360.673,288.022,359.702,287.971"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2563EB",
      strokeMiterlimit: 10
    },
    d: "M405.522,173.272c-0.971,0.051-1.102-1.588-1.18-2.049 c-0.16-0.951-0.321-1.902-0.482-2.854c-0.127-0.751-0.147-1.557-0.896-1.97c-1.218-0.672-3.27-0.335-3.473-1.291 c-0.25-1.18,2.183-1.048,2.811-1.031c0.615,0.017,1.805-0.019,1.957-0.708c0.132-0.6-0.005-1.086,0-1.692 c0.01-1.219,0.059-2.574,0.202-3.609c0.144-1.045,0.645-2.117,1.06-2.122c0.489-0.006,1.046,0.962,1.204,2.281 c0.116,0.966,0.21,4.542,0.342,5.142c0.152,0.689,1.058,0.724,1.673,0.708c0.628-0.017,3.061-0.149,2.811,1.031 c-0.203,0.956-2.254,0.619-3.473,1.291c-0.749,0.413-0.769,1.219-0.896,1.97c-0.161,0.951-0.321,1.902-0.482,2.854 C406.624,171.684,406.492,173.323,405.522,173.272"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#14B8A6",
      strokeMiterlimit: 10
    },
    d: "M153.84,175.01c-0.971,0.051-1.102-1.589-1.18-2.049 c-0.16-0.951-0.321-1.902-0.481-2.854c-0.127-0.751-0.147-1.557-0.896-1.97c-1.218-0.672-3.27-0.335-3.473-1.291 c-0.25-1.18,2.183-1.048,2.811-1.031c0.615,0.016,1.805-0.019,1.957-0.708c0.132-0.6-0.005-1.086,0-1.692 c0.01-1.219,0.059-2.574,0.202-3.609c0.144-1.045,0.645-2.117,1.06-2.122c0.489-0.006,1.046,0.962,1.204,2.281 c0.116,0.966,0.21,4.542,0.342,5.142c0.151,0.689,1.058,0.724,1.673,0.708c0.628-0.017,3.062-0.149,2.811,1.031 c-0.203,0.956-2.254,0.619-3.473,1.291c-0.749,0.413-0.769,1.219-0.896,1.97c-0.16,0.951-0.321,1.902-0.481,2.854 C154.942,173.421,154.811,175.061,153.84,175.01"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97316",
      strokeMiterlimit: 10
    },
    d: "M80.282,130.516c-0.971,0.051-1.102-1.589-1.18-2.049 c-0.16-0.951-0.321-1.902-0.481-2.854c-0.127-0.751-0.147-1.557-0.896-1.97c-1.218-0.672-3.27-0.335-3.473-1.291 c-0.25-1.18,2.183-1.048,2.811-1.031c0.615,0.016,1.805-0.019,1.957-0.708c0.132-0.6-0.005-1.086,0-1.692 c0.01-1.219,0.059-2.574,0.202-3.609c0.144-1.045,0.645-2.117,1.06-2.122c0.489-0.006,1.046,0.961,1.204,2.281 c0.116,0.966,0.21,4.542,0.342,5.142c0.151,0.689,1.058,0.724,1.673,0.708c0.628-0.017,3.062-0.149,2.811,1.031 c-0.203,0.956-2.254,0.619-3.473,1.291c-0.749,0.413-0.769,1.219-0.896,1.97c-0.16,0.951-0.321,1.902-0.481,2.854 C81.384,128.928,81.252,130.568,80.282,130.516"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B2CBF",
      strokeMiterlimit: 10
    },
    d: "M97.224,410.505c-0.971,0.051-1.102-1.589-1.18-2.049 c-0.16-0.951-0.321-1.902-0.481-2.853c-0.127-0.751-0.147-1.557-0.896-1.97c-1.218-0.672-3.27-0.335-3.473-1.292 c-0.25-1.18,2.183-1.048,2.811-1.031c0.615,0.017,1.805-0.019,1.957-0.708c0.132-0.6-0.005-1.086,0-1.692 c0.01-1.219,0.059-2.574,0.202-3.609c0.144-1.045,0.645-2.117,1.06-2.122c0.489-0.006,1.046,0.962,1.204,2.281 c0.116,0.966,0.21,4.542,0.342,5.142c0.151,0.689,1.058,0.724,1.673,0.708c0.628-0.017,3.062-0.149,2.811,1.031 c-0.203,0.956-2.254,0.619-3.473,1.292c-0.749,0.413-0.769,1.218-0.896,1.97c-0.16,0.951-0.321,1.902-0.481,2.853 C98.326,408.916,98.195,410.556,97.224,410.505"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F43F5E"
    },
    d: "M444.859,263.949 c-0.196-7.74-6.572-13.954-14.42-13.954c-7.754,0-14.076,6.072-14.413,13.691c-0.007,0.209-0.014,0.419-0.014,0.628 c0,2.708,0.756,5.235,2.067,7.396l-2.601,7.68l7.99-2.54c2.067,1.135,4.444,1.783,6.97,1.783c7.97,0,14.427-6.41,14.427-14.319 C444.865,264.192,444.865,264.071,444.859,263.949z M430.439,276.35c-2.465,0-4.755-0.729-6.673-1.992l-4.66,1.486l1.513-4.471 c-1.452-1.986-2.31-4.424-2.31-7.058c0-0.392,0.021-0.783,0.061-1.168c0.595-6.093,5.781-10.868,12.07-10.868 c6.369,0,11.604,4.897,12.09,11.097c0.027,0.311,0.041,0.621,0.041,0.939C442.569,270.953,437.125,276.35,430.439,276.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#2563EB"
    },
    d: "M437.051,267.205 c-0.358-0.175-2.094-1.027-2.418-1.141c-0.324-0.122-0.561-0.176-0.797,0.176c-0.236,0.351-0.918,1.141-1.121,1.371 c-0.209,0.236-0.412,0.264-0.77,0.088c-0.351-0.176-1.493-0.54-2.844-1.743c-1.047-0.925-1.763-2.073-1.965-2.425 c-0.203-0.351-0.02-0.54,0.155-0.716c0.162-0.162,0.351-0.412,0.533-0.614c0.048-0.061,0.088-0.115,0.129-0.169 c0.081-0.128,0.142-0.25,0.223-0.419c0.122-0.236,0.061-0.439-0.027-0.614c-0.088-0.176-0.797-1.905-1.094-2.607 c-0.29-0.702-0.587-0.581-0.797-0.581c-0.203,0-0.439-0.034-0.675-0.034s-0.621,0.088-0.946,0.439 c-0.324,0.351-1.236,1.202-1.236,2.931c0,0.405,0.075,0.81,0.182,1.195c0.358,1.236,1.128,2.256,1.263,2.432 c0.175,0.23,2.445,3.89,6.038,5.302c3.6,1.398,3.6,0.932,4.249,0.871c0.648-0.054,2.094-0.844,2.384-1.668 c0.298-0.817,0.298-1.52,0.21-1.668C437.638,267.468,437.402,267.38,437.051,267.205z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#14B8A6",
      strokeMiterlimit: 10
    },
    d: "M421.056,242.694c-5.499,2.709-14.669,11.415-14.669,21.628 c-0.001,19.798,22.118,32.66,38.523,18.503c6.72-5.8,11.291-17.396,7.901-25.6C447.277,243.829,433.133,236.744,421.056,242.694 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97316",
      strokeMiterlimit: 10
    },
    d: "M416.665,250.227c-2.104,1.692-3.655,4.061-4.363,6.666"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B2CBF",
      strokeMiterlimit: 10
    },
    d: "M411.408,260.601c-0.042,1-0.084,1.999-0.126,2.999"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F43F5E",
      strokeMiterlimit: 10
    },
    d: "M449.994,262.506c-0.323,8.087-5.139,15.85-12.242,19.73"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_93_",
    style: {
      fill: "#2563EB"
    },
    d: "M88.64,355.151h5.413v-13.557h3.777l0.403-4.539h-4.18c0,0,0-1.695,0-2.585 c0-1.07,0.215-1.493,1.25-1.493c0.833,0,2.93,0,2.93,0v-4.711c0,0-3.089,0-3.749,0c-4.028,0-5.845,1.774-5.845,5.17 c0,2.958,0,3.619,0,3.619h-2.816v4.596h2.816V355.151z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#14B8A6",
      strokeMiterlimit: 10
    },
    d: "M82.913,319.71c-5.624,2.437-14.669,11.415-14.669,21.628 c-0.001,19.798,22.118,32.66,38.523,18.503c6.72-5.8,11.065-17.735,6.921-27.787C109.662,322.29,98.233,313.072,82.913,319.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97316",
      strokeMiterlimit: 10
    },
    d: "M78.522,327.244c-2.104,1.692-3.655,4.061-4.363,6.666"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B2CBF",
      strokeMiterlimit: 10
    },
    d: "M73.265,337.618c-0.042,1-0.084,1.999-0.126,2.999"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F43F5E",
      strokeMiterlimit: 10
    },
    d: "M111.851,339.523c-0.323,8.087-5.139,15.85-12.242,19.73"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    style: {
      fill: "#2563EB"
    },
    d: "M40.263,222.861c0.353,0.145,0.67,0.006,0.773-0.385 c0.07-0.271,0.24-0.955,0.315-1.239c0.104-0.388,0.064-0.523-0.222-0.86c-0.621-0.734-1.018-1.683-1.018-3.028 c0-3.901,2.918-7.392,7.599-7.392c4.145,0,6.422,2.533,6.422,5.916c0,4.45-1.969,8.206-4.893,8.206 c-1.615,0-2.823-1.335-2.437-2.972c0.465-1.956,1.363-4.066,1.363-5.478c0-1.264-0.678-2.317-2.081-2.317 c-1.651,0-2.977,1.708-2.977,3.995c0,1.457,0.493,2.442,0.493,2.442s-1.689,7.158-1.985,8.41 c-0.59,2.496-0.089,5.556-0.046,5.865c0.025,0.184,0.26,0.227,0.367,0.089c0.153-0.199,2.118-2.627,2.786-5.051 c0.19-0.686,1.087-4.242,1.087-4.242c0.536,1.023,2.104,1.923,3.77,1.923c4.963,0,8.328-4.523,8.328-10.578 c0-4.578-3.877-8.842-9.771-8.842c-7.333,0-11.031,5.258-11.031,9.642C37.102,219.62,38.107,221.982,40.263,222.861z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#14B8A6",
      strokeMiterlimit: 10
    },
    d: "M34.237,198.454c-6.696,4.911-11.251,11.629-10.788,20.495 c0.463,8.866,6.055,17.331,14.119,21.043c8.064,3.713,18.254,2.396,24.975-3.405c6.721-5.801,11.291-17.398,7.9-25.602 C62.847,192.607,44.313,191.063,34.237,198.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97316",
      strokeMiterlimit: 10
    },
    d: "M34.298,203.99c-2.104,1.692-3.655,4.061-4.363,6.666"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B2CBF",
      strokeMiterlimit: 10
    },
    d: "M29.042,214.364c-0.042,0.999-0.084,1.999-0.126,2.999"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F43F5E",
      strokeMiterlimit: 10
    },
    d: "M67.627,216.269c-0.322,8.087-5.139,15.85-12.242,19.73"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#2563EB"
    },
    d: "M419.983,405.099c-1.051,0.455-2.195,0.769-3.403,0.925 c1.238-0.737,2.179-1.866,2.62-3.247c-1.145,0.674-2.431,1.161-3.78,1.427c-1.068-1.144-2.62-1.851-4.345-1.851 c-3.262,0-5.93,2.62-5.93,5.835c0,0.471,0.079,0.91,0.173,1.334c-4.941-0.236-9.317-2.557-12.235-6.102 c-0.502,0.879-0.815,1.867-0.815,2.933c0,2.039,1.067,3.827,2.635,4.863c-0.972-0.016-1.882-0.283-2.682-0.722 c0,0.032,0,0.047,0,0.078c0,0.753,0.141,1.443,0.407,2.102c0.722,1.836,2.369,3.216,4.361,3.608 c-0.518,0.141-1.02,0.219-1.569,0.219c-0.377,0-0.753-0.047-1.115-0.125c0.769,2.322,2.949,4.015,5.538,4.078 c-2.04,1.568-4.581,2.494-7.357,2.494c-0.487,0-0.941-0.032-1.427-0.079c2.635,1.647,5.756,2.62,9.097,2.62 c9.27,0,14.995-6.416,16.484-13.082c0.268-1.191,0.392-2.368,0.392-3.529c0-0.251,0-0.517,0-0.753 C418.179,407.295,419.199,406.259,419.983,405.099L419.983,405.099z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#14B8A6",
      strokeMiterlimit: 10
    },
    d: "M390.998,392.88c-6.696,4.911-11.251,11.629-10.788,20.495 c0.463,8.866,6.055,17.331,14.119,21.044c8.064,3.713,18.254,2.396,24.975-3.405c6.721-5.801,11.291-17.398,7.9-25.602 C419.609,387.033,401.075,385.489,390.998,392.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97316",
      strokeMiterlimit: 10
    },
    d: "M391.06,398.416c-2.104,1.691-3.655,4.061-4.363,6.666"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B2CBF",
      strokeMiterlimit: 10
    },
    d: "M385.803,408.79c-0.042,1-0.084,1.999-0.126,2.999"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F43F5E",
      strokeMiterlimit: 10
    },
    d: "M424.389,410.695c-0.322,8.087-5.139,15.85-12.242,19.73"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_92_",
    style: {
      fill: "#2563EB"
    },
    d: "M364.658,174.618h9.707v-24.308h6.773l0.722-8.139h-7.495c0,0,0-3.039,0-4.635 c0-1.919,0.385-2.677,2.241-2.677c1.493,0,5.253,0,5.253,0v-8.447c0,0-5.539,0-6.722,0c-7.223,0-10.48,3.182-10.48,9.271 c0,5.304,0,6.489,0,6.489h-5.049v8.241h5.049V174.618z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#14B8A6",
      strokeMiterlimit: 10
    },
    x1: 124.056,
    y1: 336.138,
    x2: 154.949,
    y2: 333.91
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#F97316",
      strokeMiterlimit: 10
    },
    x1: 78.015,
    y1: 221.868,
    x2: 105.86,
    y2: 227.734
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#47549B"
    },
    d: "M308.728,293.552c22.756,18.26,57.997,38.267,61.477,41.436c2.816,2.56,8.342,6.255,7.767,15.013 c-0.663,10.099-8.794,26.349-28.486,45.327c-24.735,23.84-44.734,45.949-60.505,40.654 c-13.745-4.615-150.57-125.479-150.57-125.479c-11.97-9.925-22.469-18.783-32.968-30.251c-3.121-3.408-7.836-8.53-10.506-12.308 c-6.667-9.436-5.041-14.872,1.134-20.594c2.491-2.308,4.54,1.198,7.207-0.907c22.601-17.794,45.249-35.623,69.488-51.109 c2.786-1.782,5.776-3.588,9.088-3.647c3.468-0.048,6.637,1.841,9.519,3.767c4.676,3.121,28.408,23.904,57.621,47.019"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B2CBF",
      strokeWidth: 0.9794,
      strokeMiterlimit: 10
    },
    d: "M308.728,293.552 c22.756,18.26,57.887,38.393,61.477,41.436c11.897,10.083,13.743,23.416-20.719,60.339 c-20.848,22.337-47.626,45.616-60.505,40.654c-13.525-5.226-150.57-125.479-150.57-125.479 c-11.97-9.925-22.469-18.783-32.968-30.251c-3.121-3.408-7.726-8.61-10.506-12.308c-5.324-7.082-4.938-11.84-1.995-16.8 c6.625-11.164,55.585-40.323,79.824-55.809c2.786-1.782,5.776-3.588,9.088-3.647c3.468-0.048,6.637,1.841,9.519,3.767 c4.676,3.121,28.408,23.904,57.621,47.019"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F43F5E"
    },
    d: "M308.728,287.975c22.756,18.26,54.333,40.853,57.813,44.022c3.031,2.756,9.322,9.116,8.055,18.418 c-1.266,9.302-10.089,21.545-27.684,39.408c-21.441,21.768-45.052,45.544-57.931,40.582 c-13.525-5.226-150.57-125.48-150.57-125.48c-11.97-9.925-23.246-20.675-33.746-32.143c-3.121-3.408-6.218-6.948-8.084-11.181 c-1.877-4.221-2.38-9.291-0.275-13.405c1.543-3.025,4.305-5.226,6.972-7.33c22.601-17.794,45.249-35.623,69.488-51.109 c2.786-1.782,5.776-3.587,9.088-3.647c3.468-0.048,6.637,1.841,9.519,3.767c4.676,3.121,28.744,25.909,57.958,49.024"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#DFE4F2"
    },
    d: "M293.177,430.405c-13.524-5.226-150.57-125.479-150.57-125.479 c-11.97-9.925-23.247-20.676-33.746-32.143c-3.121-3.408-6.218-6.948-8.083-11.181c-1.878-4.221-2.379-9.291-0.275-13.405 c1.543-3.025,4.305-5.226,6.972-7.33c22.601-17.794,45.249-35.623,69.488-51.109c2.231-1.427,4.596-2.853,7.15-3.402 c-0.739-0.159-1.49-0.256-2.257-0.245c-3.313,0.06-6.302,1.865-9.088,3.647c-24.239,15.486-46.888,33.315-69.488,51.109 c-2.667,2.105-5.429,4.305-6.972,7.33c-2.104,4.114-1.603,9.184,0.275,13.405c1.866,4.233,4.963,7.773,8.084,11.181 c10.499,11.468,21.775,22.218,33.746,32.143c0,0,137.045,120.254,150.57,125.479c1.814,0.699,3.868,0.828,6.102,0.5 C294.426,430.791,293.785,430.638,293.177,430.405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFE4F2"
    },
    d: "M304.753,291.455l54.362,43.423c2.846,2.274,3.928,6.115,2.665,9.532 c-0.504,1.364-1.145,3.031-1.96,5.063c-4.755,11.866-54.247,71.377-70.605,65.975c-12.951-4.269-56.119-39.585-56.119-39.585 l-85.312-75.702c-11.917-12.806-28.24-22.797-37.994-37.639c-1.802-2.106-1.744-5.31-0.581-7.816 c1.163-2.518,3.232-4.486,5.278-6.374c18.171-16.846,43.923-34.344,64.373-48.431c3.802-2.621,9.173-4.017,15.928,1.064 l54.305,43.618"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2563EB",
      strokeWidth: 0.9794,
      strokeMiterlimit: 10
    },
    d: "M295.533,277.309 c22.756,18.26,67.529,51.519,71.008,54.688c3.346,3.043,10.257,10.089,7.561,21.279c-2.189,9.083-11.608,20.725-27.19,36.547 c-21.439,21.77-45.052,45.544-57.931,40.582c-13.525-5.226-150.57-125.48-150.57-125.48 c-11.97-9.925-23.246-20.675-33.746-32.143c-3.121-3.408-6.218-6.948-8.084-11.181c-1.877-4.221-2.38-9.291-0.275-13.405 c1.543-3.025,4.305-5.226,6.972-7.33c22.601-17.794,45.249-35.623,69.488-51.109c2.786-1.782,5.776-3.587,9.088-3.647 c3.468-0.048,6.637,1.841,9.519,3.767c4.676,3.121,75.539,64.793,104.753,87.908"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#14B8A6",
      strokeWidth: 0.9448,
      strokeMiterlimit: 10
    },
    d: "M292.92,281.642l66.195,53.236 c2.846,2.274,3.928,6.115,2.665,9.532c-0.504,1.364-1.145,3.031-1.96,5.063c-4.755,11.866-54.247,71.377-70.605,65.975 c-12.951-4.269-56.119-39.585-56.119-39.585l-85.312-75.702c-11.917-12.806-28.24-22.797-37.994-37.639 c-1.802-2.106-1.744-5.31-0.581-7.816c1.163-2.518,3.232-4.486,5.278-6.374c18.171-16.846,43.923-34.344,64.373-48.431 c3.802-2.621,9.173-4.017,15.928,1.064l54.305,43.618L292.92,281.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#4455B0"
    },
    d: "M316.841,297.846l-68.102-53.784l-53.772-42.825c-6.06-4.52-12.201-4.9-17.763-1.1 l-3.115,2.127c-19.816,13.524-44.478,30.356-61.968,46.433c-2.362,2.162-4.419,4.168-5.659,6.833 c-1.544,3.298-1.251,6.942,0.739,9.317c6.149,9.249,14.851,16.674,23.267,23.854c5.196,4.434,10.569,9.02,15.154,13.905 l86.183,75.837c1.786,1.449,43.895,35.536,57.062,39.839c0.817,0.268,1.7,0.396,2.645,0.396 c19.825-0.003,66.063-56.552,70.371-67.212c0.752-1.857,1.422-3.573,1.991-5.1C365.371,342.352,364.104,337.855,316.841,297.846z  M361.133,345.345c-0.561,1.503-1.221,3.193-1.962,5.026c-2.287,5.66-15.992,23.539-30.911,38.995 c-17.788,18.43-32.17,28.21-38.484,26.138c-12.656-4.136-55.695-38.979-56.084-39.293l-85.984-75.656 c-4.685-4.984-10.102-9.607-15.341-14.077c-8.284-7.069-16.85-14.378-22.775-23.319l-0.111-0.148 c-1.474-1.707-1.247-4.365-0.367-6.244c1.014-2.178,2.856-3.966,4.985-5.915c17.337-15.936,41.902-32.702,61.64-46.173 l3.117-2.128c4.559-3.116,9.258-2.781,14.327,1.001l53.623,42.707l-0.001,0.001l112.104,91.209 C361.291,339.358,362.185,342.522,361.133,345.345z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F97316"
    },
    d: "M138.837,222.89c-0.472,0-0.936-0.222-1.229-0.637c-0.476-0.678-0.313-1.613,0.365-2.09 l11.897-8.365c0.675-0.476,1.611-0.314,2.09,0.364c0.476,0.678,0.313,1.613-0.365,2.09l-11.897,8.365 C139.437,222.801,139.136,222.89,138.837,222.89z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B2CBF"
    },
    d: "M136.023,223.992c-0.071-0.254-0.2-0.475-0.386-0.662l-0.304-0.235 c-0.234-0.136-0.486-0.204-0.757-0.205h-0.41c-0.207-0.008-0.399,0.035-0.578,0.129c-0.186,0.06-0.347,0.164-0.483,0.31 c-0.146,0.136-0.25,0.297-0.31,0.483c-0.094,0.179-0.137,0.371-0.129,0.578c0.018,0.133,0.036,0.266,0.053,0.399 c0.071,0.254,0.2,0.475,0.386,0.662l0.304,0.234c0.234,0.136,0.486,0.204,0.757,0.205h0.41c0.207,0.008,0.399-0.035,0.578-0.129 c0.186-0.06,0.347-0.164,0.483-0.31c0.146-0.136,0.249-0.297,0.31-0.483c0.094-0.179,0.137-0.371,0.129-0.578 C136.059,224.258,136.041,224.125,136.023,223.992z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#F43F5E"
    },
    d: "M359.829,350.326c0.811-2.038,1.45-3.708,1.953-5.075 c1.258-3.425,0.181-7.276-2.655-9.555l-61.655-48.896l-47.958-41.612l-52.111-45.656c-6.73-5.093-12.075-2.941-17.861,0.868 c-12.156,8.002-25.74,17.764-38.747,27.588c0.043-0.025-15.673,12.232-15.033,11.87c6.531-3.685,57.673-35.259,69.884-27.806 c13.488,8.232,154.22,124.108,159.202,131.191c4.824,6.86-44.776,57.43-67.755,72.232c0.88,0.412,1.685,0.747,2.394,0.982 C305.783,421.871,355.092,362.219,359.829,350.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2563EB",
      strokeWidth: 0.7283,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M187.898,263.992 c6.543-5.631,13.084-11.266,19.629-16.896c2.822-2.427,5.727-4.905,9.255-6.205c10.782-3.974,25.928,9.176,33.869,15.01 c11.256,8.269,21.637,17.572,32.497,26.309c6.563,5.28,13.684,9.865,19.927,15.515c1.562,1.414,3.114,3,3.647,5.006 c1.038,3.91-4.929,8.632-7.249,11.297c-9.747,11.195-20.593,22.052-32.09,31.821c-6.017,5.113-13.681,12.201-20.152,16.767 c-5.42,3.824-8.356,9.035-15.077,4.404c-7.096-4.889-70.719-59.808-74.574-63.432c-4.226-3.973-4.824-9.238,0-13.356 C167.149,282.064,178.363,272.199,187.898,263.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.64,
      fill: "#14B8A6"
    },
    d: "M187.898,263.992c6.543-5.631,13.084-11.266,19.629-16.896 c2.822-2.427,5.727-4.905,9.255-6.205c10.782-3.974,25.928,9.176,33.869,15.01c11.256,8.269,21.637,17.572,32.497,26.309 c6.563,5.28,13.684,9.865,19.927,15.515c1.562,1.414,3.114,3,3.647,5.006c1.038,3.91-4.929,8.632-7.249,11.297 c-9.747,11.195-20.593,22.052-32.09,31.821c-6.017,5.113-13.681,12.201-20.152,16.767c-5.42,3.824-8.356,9.035-15.077,4.404 c-7.096-4.889-70.719-59.808-74.574-63.432c-4.226-3.973-4.824-9.238,0-13.356C167.149,282.064,178.363,272.199,187.898,263.992z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F97316",
      stroke: "#7B2CBF",
      strokeWidth: 0.4469,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M262.285,387.293c-1.152-0.143-2.311-0.807-3.183-1.943c-1.682-2.194-1.658-5.323,0.055-6.988l42.917-41.732 c1.713-1.665,4.464-1.235,6.147,0.958c1.682,2.194,1.658,5.323-0.055,6.988l-42.917,41.732 C264.424,387.11,263.357,387.426,262.285,387.293z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F43F5E",
      stroke: "#2563EB",
      strokeWidth: 0.4469,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M253.53,375.733c-0.248-0.031-0.498-0.174-0.686-0.419c-0.362-0.473-0.358-1.148,0.012-1.507l38.166-37.112 c0.37-0.358,0.962-0.267,1.326,0.206c0.362,0.473,0.358,1.148-0.012,1.507L254.17,375.52 C253.992,375.694,253.762,375.762,253.53,375.733z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14B8A6",
      stroke: "#F97316",
      strokeWidth: 0.481,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M315.315,313.447 c-2.847,0.68-2.665,4.025-2.412,5.595c0.06,0.372-0.237,0.69-0.576,0.616c-1.429-0.312-4.481-0.586-5.166,2.514 c-2.011,9.099,10.79,6.434,12.917,5.933c0.182-0.043,0.326-0.196,0.369-0.395C320.953,325.395,323.673,311.45,315.315,313.447z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B2CBF",
      stroke: "#F43F5E",
      strokeWidth: 0.5511,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M145.868,288.779c-1.524-0.194-3.07-0.987-4.249-2.318c-2.274-2.571-2.32-6.176-0.1-8.054l55.62-47.047 c2.22-1.877,5.862-1.313,8.137,1.256c2.274,2.571,2.32,6.176,0.1,8.054l-55.62,47.047 C148.687,288.621,147.286,288.959,145.868,288.779z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2563EB",
      stroke: "#14B8A6",
      strokeWidth: 0.5511,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M134.028,275.238c-0.328-0.042-0.661-0.213-0.916-0.5c-0.49-0.555-0.5-1.332-0.021-1.737l49.462-41.838 c0.479-0.404,1.263-0.284,1.755,0.27c0.49,0.554,0.5,1.332,0.021,1.737l-49.462,41.838 C134.636,275.204,134.334,275.277,134.028,275.238z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F97316",
      stroke: "#7B2CBF",
      strokeWidth: 0.4469,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M257.563,317.873 c-0.204,2.354,2.791,3.393,4.65,4.852c3.441,2.702,2.725,9.038-1.231,10.904c-4.55,2.146-9.726-1.444-14.756-1.406 c-3.542,0.026-6.808,1.863-10.293,2.499c-4.172,0.762-8.645-0.301-12.028-2.858c-6.414-4.847-9.092-14.632-16.872-16.659 c-2.735-0.712-5.699-0.281-8.371-1.2c-4.89-1.682-7.312-7.974-5.406-12.781c1.906-4.807,7.343-7.711,12.501-7.35 c0,0,20.97,16.294,30.949,17.758C246.683,313.095,257.563,317.873,257.563,317.873z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M249.122,177.806c0.746-1.395,5.282-19.836,6.834-20.65c3.762-1.972,13.177,5.646,13.47,8.525 c0.275,2.698-7.614,22.11-8.685,25.569l-7.997,4.015L249.122,177.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M206.863,308.286c0,0-4.622-4.172-4.48-6.69c-0.372,1.496,10.409-19.836,13.471-32.298 c2.3-9.361,1.848-13.968,0.486-20.654c-1.363-6.686-2.41-12.296-2.007-18.435c0.403-6.139-3.933-18.325-3.933-18.325 l-1.664-8.357c0,0-2.086-11.684,2.526-13.453c4.612-1.769,6.784,2.329,6.784,2.329l3.697,4.402l3.586,10.848l4.603,7.128 c0,0,18.611-29.855,19.908-32.208c0.039-0.071,4.753,9.136,4.753,9.136s9.697-5.167,13.908,2.625 c2.484,4.597,1.355,6.159,1.355,6.159s6.487,2.851,12.558,8.878c0.848,1.17,2.042,3.824,2.25,5.689 c0,0,15.746,5.217,19.339,9.145c-0.027-0.029,0.836,4.067,0.96,7.216c0.346,8.739-2.433,16.256-2.433,16.256 c-0.158,2.788-7.148,15.162-7.148,15.162l-2.698,5.66c-1.289,2.704-2.761,5.318-4.407,7.821l-3.137,4.772l-5.891,7.67 l-13.091,15.107c0,0-9.32,13.8-10.531,19.468c-1.211,5.669-2.094,6.067-3.821,5.654c-1.727-0.413-26.771-7.899-33.116-12.666"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F43F5E",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M208.629,198.754 c-0.872,9.669,4.834,19.514,5.609,29.191c0.272,3.394-0.121,6.816,0.173,10.208c0.307,3.544,1.356,6.979,1.93,10.49 c0.963,5.895,0.785,14.807,0.168,17.878c-1.609,8.003-8.552,27.198-14.125,35.074c-0.54,0.763,0.005,1.482,0.535,2.253 c10.232,14.91,49.208,26.482,50.51,24.866c1.535-1.906,1.906-4.59,2.764-6.831c1.06-2.771,2.284-5.479,3.661-8.107 c4.918-9.385,12.193-17.169,19.063-25.128c5.67-6.569,10.294-13.934,14.355-21.584c2.712-5.11,5.743-10.065,7.932-15.435 c3.089-7.578,4.398-17.218,3.816-25.397c-0.302-4.251-16.24-9.144-19.918-10.97c-3.678-1.825-6.479-1.527-8.597,1.282 c-2.118,2.809-11.951,10.956-10.698,13.99c1.253,3.035,2.921,3.138,8.332,2.929c5.411-0.209,10.801-7.667,10.801-7.667"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2563EB",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M210.511,190.692 c-1.747,1.006-2.548,3.18-2.474,5.195c0.074,2.015,1.893,7.45,3.52,8.04c0.931,0.338,1.964,0.219,2.929-0.005 c0.855-0.199,1.728-0.499,2.335-1.133c0.827-0.865,0.986-2.157,1.033-3.353c0.056-1.436,0.009-2.876-0.139-4.306 c-0.184-1.774,0.302-2.387-0.838-3.758C215.063,189.193,212.117,189.768,210.511,190.692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#14B8A6",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M216.877,191.372 c2.003,1.744,3.566,3.117,4.867,5.433c1.609,2.864,1.933,6.254,3.003,9.36c1.902,5.52,6.053,9.905,9.637,14.513 c10.63,13.67,16.937,31.325,14.377,48.452"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#F97316"
    },
    d: "M304.994,230.065c-0.125-3.149-1.017-5.891-0.99-5.862 c-0.116-0.128-0.247-0.256-0.388-0.386c-3.348,18.922-13.393,36.621-28.016,49.102c-7.459,6.367-16.352,11.79-20.633,20.613 c-2.631,5.422-3.572,12.152-8.44,15.704c-3.72,2.715-8.928,2.712-13.185,0.955c-4.256-1.758-7.706-5.029-10.717-8.514 c-2.851-3.299-5.687-7.049-9.869-8.285c-2.079-0.615-4.153-0.518-6.181,0.022c-2.257,4.833-4.038,8.231-4.188,8.251 c-0.059,2.524,4.476,6.622,4.476,6.622l11.829,8.036c6.344,4.768,31.388,12.253,33.116,12.666 c1.727,0.413,2.61,0.014,3.821-5.654c1.211-5.669,10.531-19.468,10.531-19.468l13.091-15.107l5.89-7.67l3.137-4.772 c1.646-2.504,3.118-5.117,4.407-7.821l2.698-5.66c0,0,6.99-12.374,7.148-15.162 C302.531,247.674,305.341,238.804,304.994,230.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#7B2CBF"
    },
    d: "M202.387,301.664c0.001-0.022-0.005-0.047-0.004-0.069 C202.371,301.648,202.374,301.666,202.387,301.664z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#F43F5E"
    },
    d: "M248.231,248.359c1.682,7.386,2.898,14.141,1.355,21.557 c4.333-14.621,7.312-28.667,6.112-43.869c-0.309-3.916-1.009-7.864-2.746-11.387c-0.953-1.933-2.2-3.703-3.442-5.464 c-3.241-4.596-5.449-12.891-8.69-17.487c-0.988,5.133-10.887,23.071-10.887,23.071c0.208,1.894,6.09,7.625,7.125,9.164 C242.248,231.662,246.193,239.414,248.231,248.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2563EB"
    },
    d: "M208.365,166.285c0,0,5.204,19.736,16.715,35.319c10.222,13.839,8.289,13.299,8.289,13.299 s22.545,31.927,31.231,35.633c-0.233,0.299,1.816,2.519,3.717,1.975c1.901-0.544,8.943-8.943,8.943-8.943l6.267-6.435 l-4.634-5.443c0,0-4.722,2.193-7.505,1.897c-2.784-0.296-3.694-0.04-4.967-1.867c-1.273-1.827,0.218-4.186,1.355-5.824 c1.137-1.638,5.569-6.3,5.569-6.3s-3.922-6.085-4.137-6.063c-0.215,0.022-2.725,1.787-5.463,2.645 c-2.738,0.859-8.182,1.729-10.924,0.292c-2.742-1.436-2.371-3.226-2.284-4.829c0.087-1.603,2.736-6.077,2.736-6.077 s-2.286-0.937-3.854-2.264s-1.804-5.439,0.187-7.563c1.991-2.123,4.987-4.029,4.987-4.029s-7.035-13.065-8.487-24.084 c-0.116-1.135-22.849,4.386-30.732-2.8c-0.121-0.089-2.115,0.962-4.563,1.212C208.365,166.285,208.365,166.285,208.365,166.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#14B8A6",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M248.886,178.426 c0.746-1.395,4.952-19.578,6.504-20.392c3.762-1.972,14.312,3.197,14.605,6.076c0.275,2.698-7.91,22.714-8.982,26.173"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F97316"
    },
    d: "M311.119,54.793c0,0-3.239-0.462-4.596,6.12c-1.358,6.582-5.213,43.291-3.605,60.023 c0.854,8.887,1.728,42.353,6.599,53.542c1.006,2.31,2.253,2.618,3.627,2.729c9.401,0.76,9.057-40.892,9.057-40.892l-1.173-43.449 c-0.018-1.946-0.12-3.882-0.308-5.819c-0.469-4.845-0.62-14.881-0.881-16.696C319.482,67.878,318.391,54.822,311.119,54.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B2CBF"
    },
    d: "M208.365,166.285c0,0,7.236,19.383,17.279,35.951c5.765,9.511,8.022,12.757,8.022,12.757 s21.853,30.525,30.592,35.578c0.467,0.061,2.857,2.559,4.582,1.937c1.86-0.671,7.866-8.134,7.866-8.134l6.505-7.032l-4.06-5.351 c0,0-5.32,1.928-8.104,1.632c-2.784-0.296-3.177,0.183-4.45-1.644c-1.273-1.827-0.214-4.07,0.924-5.708 c1.137-1.638,5.825-6.674,5.825-6.674s-3.922-6.085-4.137-6.063c-0.215,0.022-3.067,1.822-5.806,2.68s-7.115,2.141-9.857,0.705 c-2.742-1.436-3.151-4.21-3.064-5.813c0.087-1.603,3.031-5.353,3.031-5.353s-2.233-0.874-3.801-2.202 c-1.568-1.327-2.482-5.21-0.491-7.333c1.991-2.123,5.373-4.508,5.373-4.508s-7.902-12.975-9.354-23.995 c-0.116-1.136-21.781,4.087-29.663-3.098c-0.121-0.089-2.659,1.206-5.107,1.456C209.184,166.546,209.444,166.495,208.365,166.285 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F43F5E"
    },
    d: "M249.539,108.234l2.574,29.339l4.28,27.867c0,0,11.209-0.599,22.851,3.906 c11.642,4.505,23.285,10.364,33.899,7.86c0.129-0.065-3.79,0.772-5.492-10.109c-1.702-10.88-5.481-33.814-4.759-47.945 c0.722-14.132,0.161-31.257,0.987-35.807c0.825-4.55,2.21-19.969,2.478-21.567c0.268-1.599,1.244-6.233,4.442-6.977 c3.199-0.744-6.152,0.62-9.819,6.337c-5.325,8.302-13.039,22.492-20.418,28.796c-7.379,6.304-19.402,13.803-19.402,13.803 L249.539,108.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2563EB"
    },
    d: "M242.026,109.071c0,0-35.334,2.836-34.12,25.82c1.379,26.108,7.459,30.337,10.289,31.495 c2.83,1.158,11.016,2.691,18.149,2.201c7.133-0.491,12.803-2.241,12.803-2.241s-5.678-34.327-5.957-37.199 C242.912,126.275,242.026,109.071,242.026,109.071z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14B8A6"
    },
    d: "M245.35,105.348c0,0-4.595-0.106-3.167,13.081c1.436,13.263,6.964,47.917,6.964,47.917 s0.407,2.708,3.86,2.367c5.165-0.509,1.933-12.744,1.933-12.744l-5.4-47.735C249.539,108.234,248.864,104.211,245.35,105.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#DFE4F2"
    },
    d: "M236.456,119.996c2.044-0.324,4.094-0.59,6.137-0.354 c-0.292-5.228-0.567-10.572-0.567-10.572s-35.303,3.148-34.121,25.82c0.165,3.159,0.433,5.995,0.734,8.544 c0.158,1.341,2.102,1.275,2.205-0.071c0.003-0.041,0.006-0.081,0.01-0.122c0.419-5.282,1.903-10.676,5.398-14.658 C221.183,122.968,229.073,121.165,236.456,119.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#F97316"
    },
    d: "M311.118,54.793c0,0-0.013-0.002-0.037-0.004c1.429,4.561,3.113,10.104,3.96,13.513 c1.638,6.596,2.481,88.824-2.342,94.329c-2.286,2.609-4.858-1.257-6.993-6.039c0.896,7.348,2.108,13.977,3.81,17.885 c1.006,2.31,2.253,2.617,3.627,2.729c9.401,0.76,9.057-40.892,9.057-40.892l-1.173-43.449c-0.018-1.946-0.12-3.882-0.308-5.819 c-0.469-4.845-0.62-14.881-0.882-16.696C319.482,67.878,318.391,54.822,311.118,54.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B2CBF",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M256.394,165.44 c11.523-1.492,23.633,4.282,34.493,8.411c7.271,2.764,15.623,5.083,23.284,3.234"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F43F5E",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M311.738,54.826 c-4.164,0.655-7.925,2.598-10.484,5.948c-2.559,3.35-4.325,7.222-6.395,10.894c-9.529,16.904-26.984,31.641-45.723,36.679"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2563EB",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M249.147,166.346 c-6.765,1.827-13.591,2.795-20.59,2.169c-5.099-0.455-11.819-1.52-14.99-6.06c-1.449-2.076-2.264-4.534-2.936-6.987 c-1.748-6.377-2.535-12.985-2.716-19.594c-0.134-4.9,1.064-8.992,3.154-12.383c6.27-10.172,20.564-14.028,30.958-14.42"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#14B8A6",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M208.62,129.266 c-4.863,1.351-10.344,3.108-10.377,6.274s0.745,6.277,1.517,9.347c1.105,4.391,2.209,8.782,3.314,13.173 c0.86,3.418,2.313,7.439,5.759,8.177c2.138,0.458,4.282-0.583,6.221-1.593"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97316",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M202.62,156.894 c-1.232,0.305-2.465,0.61-3.697,0.915c-0.836,0.207-1.777,0.4-2.514-0.046c-0.681-0.412-0.966-1.24-1.201-2.001 c-0.572-1.851-1.143-3.702-1.714-5.552c-0.4-1.295-0.799-2.696-0.357-3.977c0.38-1.1,4.626-3.063,5.776-3.24"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B2CBF",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M273.345,219.595 l-3.542-5.648c-0.288-0.487-0.953-0.583-1.363-0.192c-1.914,1.821-7.661,3.959-11.237,3.637c-4.51-0.406-7.669-2.369-6.216-7.407 c1.453-5.038,7.144-8.027,11.628-9.588c8.448-2.94,22.469,10.928,22.05,14.661"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F43F5E",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M283.06,224.338 c1.844,1.328,3.824,2.468,5.898,3.396"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2563EB",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M269.857,200.491 c0,0,0.62-4.748-2.954-8.192c-1.414-1.363-3.559-1.999-5.889-2.016c-1.342-0.012-2.746,0.186-4.108,0.573 c-0.794,0.219-1.577,0.503-2.319,0.854c-1.37,0.631-2.62,1.47-3.62,2.488c-1.021,1.031-1.751,1.983-2.254,2.851 c-3.668,6.35,5.029,8.466,5.029,8.466"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#14B8A6",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M256.906,190.857 c0.722,0.644,1.868,2.034,2.264,2.997c0.175,0.418,0.246,0.902,0.142,1.343c-0.023,0.096-0.052,0.193-0.092,0.285 c-0.171,0.382-0.489,0.668-0.797,0.948c-2.115,1.882-5.873,4.323-6.003,4.342c-0.174,0.023-0.335-0.093-0.473-0.2 c-1.039-0.827-2.18-2.603-3.234-3.522c-0.055-0.055-0.11-0.105-0.17-0.148"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97316",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M269.848,223.649 c0.96,0.638,1.801,1.454,2.469,2.394c0.075,0.106,0.15,0.217,0.176,0.344c0.043,0.209-0.051,0.419-0.147,0.609 c-1.157,2.278-3.056,4.173-5.337,5.324"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B2CBF",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M246.001,167.13 c0,0,3.962,18.96,8.585,24.579"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F43F5E",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M231.296,211.9 c-1.184,2.506-1.283,3.274-1.718,2.731"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2563EB",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M252.348,207.173 l4.271,4.483l7.818-4.958c0,0-2.48-5.012-4.477-5.249"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14B8A6"
    },
    d: "M303.192,104.012c0,0,22.017-2.549,23.871,15.623c2.323,22.758-22.87,20.089-22.87,20.089 L303.192,104.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#F97316"
    },
    d: "M327.063,119.634c-0.308-3.02-1.182-5.457-2.41-7.439 c-0.288,3.757,0.238,7.688-1.104,11.218c-1.326,3.488-4.415,6.007-7.798,7.29c-3.73,1.415-7.823,1.861-11.773,1.302l0.217,7.718 C304.193,139.723,329.386,142.392,327.063,119.634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B2CBF",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M302.865,104.154 c6.868-1.501,16.62,1.19,21.008,6.682c4.389,5.492,4.248,15.855,0.331,21.692c-4.321,6.44-11.722,6.73-19.423,7.647"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#F43F5E"
    },
    d: "M254.281,151.681l2.113,13.759c0,0,11.209-0.599,22.851,3.906 c11.643,4.505,23.285,10.364,33.899,7.861c0.129-0.065-3.79,0.772-5.492-10.109c-0.264-1.688-0.578-3.668-0.917-5.858 c-2.969,0.628-6.064,0.65-9.061,0.153c-8.996-1.49-16.676-7.371-25.476-9.762C266.433,150.065,260.108,150.087,254.281,151.681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2563EB",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M321.741,108.706 c-1.528-37.506-2.077-53.82-10.004-53.88c-1.633-0.012-3.186,0.88-4.029,2.278c-0.844,1.398-1.112,3.058-1.351,4.674 c-5.323,35.865-4.706,72.604,1.82,108.27c0.311,1.699,0.656,3.447,1.613,4.885c0.957,1.438,2.69,2.501,4.382,2.151 c1.903-0.394,3.286-2.223,3.836-4.086c3.487-11.819,3.222-25.838,4.326-38.273"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#DFE4F2"
    },
    d: "M300.981,61.138c-5.325,8.302-13.039,22.492-20.418,28.796 c-7.379,6.304-19.402,13.803-19.402,13.803l-11.62,4.497l1.742,19.858c5.412,1.491,11.661-0.017,15.408-4.2 c5.677-6.339,4.86-16.745,10.753-22.883c5.488-5.717,15.277-6.047,19.969-12.434c4.026-5.48,2.654-13.117,4.376-19.696 c0.879-3.359,2.628-6.478,4.997-9.013c0.564-1.984,1.712-4.53,4.013-5.066C313.998,54.057,304.647,55.421,300.981,61.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#14B8A6",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M249.428,167.286 c0.871,2.409,7.384,2.354,6.434-3.635c-2.093-13.195-5.024-36.128-6.378-52.421c-0.191-2.302-0.207-5.91-2.516-5.975 c-2.091-0.059-3.574,0.574-4.383,2.161c-0.809,1.587-0.8,3.451-0.749,5.231C242.337,130.161,248.835,165.646,249.428,167.286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#F97316"
    },
    d: "M231.771,160.387c-6.836,0.402-13.107-1.928-18.351-6.231 c-0.704-0.578-2.074-1.761-3.412-2.306c2.452,11.232,6.134,13.698,8.186,14.537c2.83,1.158,11.016,2.691,18.149,2.201 c7.133-0.491,12.803-2.241,12.803-2.241s-0.885-5.348-1.972-11.994c-1.594,0.999-3.14,2.095-4.785,3.007 C239.141,159.162,235.475,160.169,231.771,160.387z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B2CBF",
      strokeWidth: 0.9371,
      strokeMiterlimit: 10
    },
    d: "M222.75,139.152"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F43F5E"
    },
    d: "M241.31,173.394c0,0,2.687,10.089,7.911,22.822c0.119-0.168,0.246-0.33,0.386-0.48 c1.991-2.124,4.987-4.029,4.987-4.029s-7.034-13.065-8.487-24.084c-0.116-1.135-22.85,4.386-30.731-2.8 c-0.105-0.078-1.634,0.71-3.644,1.079c-0.16,0.194-0.259,0.315-0.259,0.315s6.431,9.127,16.794,8.506 C238.629,174.102,241.31,173.394,241.31,173.394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2563EB"
    },
    d: "M267.776,225.896c1.138-1.638,5.569-6.3,5.569-6.3s-3.922-6.085-4.136-6.063 c-0.215,0.022-2.725,1.787-5.463,2.645c-1.13,0.354-2.722,0.708-4.392,0.903c2.193,3.783,4.58,7.469,7.158,10.897 C266.872,227.227,267.349,226.51,267.776,225.896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14B8A6"
    },
    d: "M283.527,237.132l-4.634-5.443c0,0-4.722,2.193-7.506,1.897 c-0.102-0.011-0.185-0.017-0.283-0.027c1.596,1.759,3.254,3.405,4.973,4.903c1.588,1.283,3.194,1.645,4.668,1.524 L283.527,237.132z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#DFE4F2"
    },
    d: "M270.103,245.614c-1.722-0.32-3.68,0.598-5.164-0.332 c-1.701-1.066-1.398-3.555-1.326-5.561c0.116-3.267-1.307-6.89-4.339-8.113c-1.46-0.589-3.085-0.55-4.638-0.813 c-3.27-0.553-6.27-2.541-8.055-5.335c-2.95-4.616-2.394-10.525-2.656-15.997c-0.216-4.521-1.065-9.011-2.516-13.298 c-0.777-2.295-1.74-4.56-3.215-6.482c-3.011-3.921-7.872-6.029-12.732-6.936c-3.035-0.566-6.172-0.674-9.233-0.247 c-0.744,0.104-0.742,0.072-1.503,0.246c2.386,5.526,5.007,10.366,10.089,18.43c9.173,14.556,8.553,13.725,8.553,13.725 s22.917,30.923,31.231,35.633c-0.233,0.298,1.816,2.519,3.717,1.975c0.892-0.255,2.914-2.24,4.811-4.275 C272.566,246.942,271.475,245.87,270.103,245.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97316",
      strokeWidth: 0.6935,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M208.834,166.237 c4.406,25.184,44.601,77.707,56.002,84.549c3.116-4.057,11.907-13.435,15.93-16.595"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMarketing);
export default __webpack_public_path__ + "static/media/digital-marketing.7cc8c0bf55758a63257f259b160a93ac.svg";
export { ForwardRef as ReactComponent };